/**
 * Empty-state component shown when the saved-cards list is empty.
 */

import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import { UI_CONFIG } from '../../../utils/constants';

export interface EmptySavedCardsProps {
  onAddCard: () => void;
}

const EmptySavedCards: React.FC<EmptySavedCardsProps> = ({ onAddCard }) => (
  <Box sx={{ p: 3, textAlign: 'center' }}>
    <Typography sx={{ color: UI_CONFIG.TEXT_COLOR, mb: 2 }}>
      No saved card found for this account.
    </Typography>
    <Button
      variant="contained"
      onClick={onAddCard}
      sx={{ background: UI_CONFIG.PRIMARY_COLOR }}
    >
      Add card
    </Button>
  </Box>
);

export default EmptySavedCards;
